import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Tooltip from 'material-ui/internal/Tooltip';

const StyledStatusLabel = styled.div`
    display: inline-block;
    padding: 7px 10px !important;
    margin: 10px 10px 0 0;
    font-size: 12px;
    line-height: 1.1;
    border: none;
    border-radius: 20px;
    text-transform: uppercase;
    background-color: ${ (props) => {
        return props.background;
    } };
`;

class StatusLabelField extends Component {
    constructor() {
        super();

        this.state = {
            isVisible: false,
        };
    }

    render() {
        const { isVisible } = this.state;

        const {
            background,
            label,
            tooltip,
        } = this.props;

        return (
            <div
                style={ { position: 'relative' } }
                onMouseEnter={ () => {
                    return this.setState({ isVisible: true });
                } }
                onMouseLeave={ () => {
                    return this.setState({ isVisible: false });
                } }
            >
                <StyledStatusLabel background={ background }>
                    {label}
                </StyledStatusLabel>
                <Tooltip
                    label={ tooltip }
                    show={ isVisible }
                    horizontalPosition='center'
                    verticalPosition='top'
                    touch={ true }
                />
            </div>
        );
    }
}

StatusLabelField.defaultProps = {
    tooltip: '',
};

StatusLabelField.propTypes = {
    background: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    tooltip: PropTypes.string,
};

export default StatusLabelField;



// WEBPACK FOOTER //
// ./src/components/show/StatusLabelField.js